<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>工讀生管理</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/"><i class="fa fa-home"></i></a>
          </li>
          <li><span>助學金管理系統</span></li>
          <li><span>工讀生管理</span></li>
          <li><span>開放排班設定</span></li>
        </ol>
      </div>
    </header>
    <div class="row">
      <div class="col-md-12">
        <section class="panel">
          <ul class="nav nav-tabs" role="tablist">
            <li>
              <router-link :to="'/workstudy'">工讀生清單</router-link>
            </li>
            <li v-if="isAdmin('stipendMage')">
              <router-link :to="'/workstudy/treaty'">設定隱私權宣告、管理辦法</router-link>
            </li>
            <li class="active" v-if="isAdmin('stipendMage')">
              <router-link :to="'/workstudy/scheduleSetting'">開放排班設定</router-link>
            </li>
          </ul>
          <header class="panel-heading">
            <h2 class="panel-title">排班開放設定</h2>
          </header>
          <div class="panel-body container-fluid">
            <div class="row form-group">
              <div class="col-md-12 form-group">
                <label class="col-md-3 control-label">開放排班：</label>
                <div class="col-md-9">
                  <label class="radio-inline">
                    <input type="radio" v-model="form.isLockOpen" :value="true"> 開啟
                  </label>
                  <label class="radio-inline">
                    <input type="radio" v-model="form.isLockOpen" :value="false"> 關閉
                  </label>
                </div>
              </div>
              <div class="col-md-12 form-group">
                <label class="col-md-3 control-label">提早鎖定班表年月：</label>
                <div class="col-md-9">
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.lockYearMonth"
                    placeholder="格式 yyyyMM，多筆以逗號分隔，例：202302,202307"
                    :style="{maxWidth: '400px'}"
                  />
                  <p class="help-block">輸入後，該年月的班表將立即鎖定，不可新增或刪除排班。</p>
                </div>
              </div>
            </div>
            <div class="row form-group">
              <div class="col-md-12 text-center">
                <button @click="handleCancel" class="btn btn-default" style="margin-right:8px;">取消</button>
                <button @click="handleSave" class="btn btn-primary">儲存</button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      form: {
        isLockOpen: false,
        lockYearMonth: ""
      }
    };
  },
  created() {
    this.$axios.get("/api/systemsetting?key=WorkstudyScheduleSetting").then(resp => {
      if (resp.data.status === "success" && resp.data.data && resp.data.data.value) {
        try {
          const parsed = JSON.parse(resp.data.data.value);
          this.form.isLockOpen = parsed.isLockOpen;
          this.form.lockYearMonth = parsed.lockYearMonth || "";
        } catch (e) {
          // 解析失敗時保留預設值
        }
      }
    });
  },
  methods: {
    handleCancel() {
      this.$router.push({ path: "/workstudy" });
    },
    handleSave() {
      const body = {
        key: "WorkstudyScheduleSetting",
        value: JSON.stringify(this.form)
      };
      this.$axios.post("/api/systemsetting", body).then(resp => {
        if (resp.data.status === "success") {
          bootbox.alert("儲存成功");
        } else {
          bootbox.alert(resp.data.msg || "儲存失敗");
        }
      });
    }
  }
};
</script>

<style scoped>
</style>
